import { createAsyncThunk } from "@reduxjs/toolkit";
import type { NormalizedFilters, RawCategory } from "@interfaces/filters";
import userService from "@userService";
import { normalizeCategories } from "./utils";

export const fetchFiltersByMarketId = createAsyncThunk<
  NormalizedFilters,
  { marketIds: number[]; module: string },
  { rejectValue: string }
>("filters/fetchByMarketId", async ({ marketIds, module }, thunkAPI) => {
  try {
    const response: RawCategory[] = (await userService.filters.getFilters(
      marketIds,
      module
    )) as any;
    return normalizeCategories(response as RawCategory[]);
  } catch (err: any) {
    return thunkAPI.rejectWithValue("Fetch filters failed " + err.message);
  }
});
